import React from 'react';

import ActivityPack from './activity_pack';

import { requestGet, } from '../../../../../modules/request';
import { DropdownInput, Snackbar, defaultSnackbarTimeout, EXTRA_SMALL_ICON_BASE_SRC, getPageTitle, } from '../../../../Shared/index';
import { MY_ACTIVITIES_FEATURED_BLOG_ID } from '../../../constants/featuredBlogPost';
import getParameterByName from '../../modules/get_parameter_by_name';
import { PROGRESS_REPORTS_SELECTED_CLASSROOM_ID, } from '../../progress_reports/progress_report_constants';
import ArticleSpotlight from '../../shared/articleSpotlight';
import LoadingIndicator from '../../shared/loading_indicator';

const groupSrc = `${EXTRA_SMALL_ICON_BASE_SRC}/group.svg`

const ALL = 'ALL'
const ALL_OPTION = { label: `<p><img alt="" src=${groupSrc} /><span>All Classes</span></p>`, value: ALL }

export default class ManageUnits extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      allUnits: [],
      units: [],
      loaded: false,
      classrooms: [],
      selectedClassroomId: getParameterByName('classroom_id') || ALL,
      activityWithRecommendationsIds: [],
      snackbarCopy: null,
      showSnackbar: false
    };
    document.title = getPageTitle("Manage Activities", `My ${props.open ? 'Open' : 'Closed'} Activity Packs`)
  }

  componentDidMount() {
    this.getClassrooms()
    this.getRecommendationIds();
    window.onpopstate = () => {
      this.setState({ loaded: false, selectedClassroomId: getParameterByName('classroom_id'), });
      this.getUnitsForCurrentClassAndOpenState();
    };
  }

  componentDidUpdate(previousProps) {
    const { open } = this.props
    if(previousProps.open !== open) {
      document.title = getPageTitle("Manage Activities", `My ${open ? 'Open' : 'Closed'} Activity Packs`)
    }
  }

  getClassrooms = () => {
    const { selectedClassroomId, } = this.state
    requestGet(
      `${window.postbuildEnv.DEFAULT_URL}/teachers/classrooms/classrooms_i_teach`,
      (body) => {
        const classrooms = body.classrooms;
        const localStorageSelectedClassroomId = window.localStorage.getItem(PROGRESS_REPORTS_SELECTED_CLASSROOM_ID)
        const classroomFromLocalStorageClassroomId = classrooms.find(c => Number(c.id) === Number(localStorageSelectedClassroomId))
        if ((!selectedClassroomId || selectedClassroomId === ALL) && classroomFromLocalStorageClassroomId) {
          this.setState({selectedClassroomId: Number(localStorageSelectedClassroomId)})
        }
        this.handleClassrooms(classrooms);
      }
    )
  };

  getRecommendationIds = () => {
    fetch(`${window.postbuildEnv.DEFAULT_URL}/teachers/progress_reports/activity_with_recommendations_ids`, {
      method: 'GET',
      mode: 'cors',
      credentials: 'include',
    }).then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response.json();
    }).then((response) => {
      this.setState({ activityWithRecommendationsIds: response.activityWithRecommendationsIds, });
    }).catch((error) => {
      // to do, use Sentry to capture error
    });
  };

  handleClassrooms = (classrooms) => {
    if (classrooms.length > 0) {
      this.setState({ classrooms, }, () => this.getUnits());
    } else {
      this.setState({ empty: true, loaded: true, });
    }
  };

  hashLinkScroll = () => {
    const hash = window.location.hash;
    if (hash !== '') {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      element ? element.scrollIntoView() : null;
    }
  };

  getUnits = () => {
    requestGet(`${window.postbuildEnv.DEFAULT_URL}/teachers/units`, (body) => {
      this.setAllUnits(body);
    });
  };

  getUnitsForCurrentClassAndOpenState = () => {
    const { selectedClassroomId, classrooms, allUnits, } = this.state
    if (selectedClassroomId && selectedClassroomId !== ALL) {
      // TODO: Refactor this. It is ridiculous that we need to find a classroom and match on name. Instead, the units should just have a list of classroom_ids that we can match on.
      const selectedClassroom = classrooms.find(c => c.id === Number(selectedClassroomId));
      const unitsInCurrentClassroom = allUnits.filter(unit => unit.classrooms.find(c => c.name === selectedClassroom.name));
      this.setState({ units: unitsInCurrentClassroom, loaded: true, });
    } else {
      this.setState(prevState => ({ units: prevState.allUnits, loaded: true, }));

    }
  };

  generateNewCaUnit = (u) => {
    const classroom = {
      name: u.class_name,
      totalStudentCount: u.class_size,
      assignedStudentCount: u.number_of_assigned_students ?? u.class_size,
    };
    const caObj = {
      classrooms: [classroom],
      classroomActivities: new Map(),
      unitId: u.unit_id,
      unitCreated: u.unit_created_at,
      unitName: u.unit_name,
      open: u.open
    };
    caObj.classroomActivities.set(u.activity_id, {
      name: u.activity_name,
      activityId: u.activity_id,
      created_at: u.unit_activity_created_at,
      cuId: u.classroom_unit_id,
      activityClassificationId: u.activity_classification_id,
      classroomId: u.classroom_id,
      dueDate: u.due_date,
      publishDate: u.publish_date,
      scheduled: u.scheduled,
      staggered: u.staggered,
      ownedByCurrentUser: u.owned_by_current_user,
      ownerName: u.owner_name,
      uaId: u.unit_activity_id,
    });
    return caObj;
  };

  parseUnits = (data) => {
    const parsedUnits = {};
    data.forEach((u) => {
      if (!parsedUnits[u.unit_id]) {
        // if this unit doesn't exist yet, go create it with the info from the first ca
        parsedUnits[u.unit_id] = this.generateNewCaUnit(u);
      } else {
        const caUnit = parsedUnits[u.unit_id];
        if (caUnit.classrooms.findIndex(c => c.name === u.class_name) === -1) {
          // add the info and student count from the classroom if it hasn't already been done
          const classroom = {
            name: u.class_name,
            totalStudentCount: u.class_size,
            assignedStudentCount: u.number_of_assigned_students ?? u.class_size,
          };
          caUnit.classrooms.push(classroom);
        }
        // add the activity info if it doesn't exist
        caUnit.classroomActivities.set(u.activity_id,
          caUnit.classroomActivities[u.activity_id] || {
            name: u.activity_name,
            cuId: u.classroom_unit_id,
            activityId: u.activity_id,
            created_at: u.unit_activity_created_at,
            activityClassificationId: u.activity_classification_id,
            classroomId: u.classroom_id,
            createdAt: u.ca_created_at,
            dueDate: u.due_date,
            publishDate: u.publish_date,
            staggered: u.staggered,
            scheduled: u.scheduled,
            ownedByCurrentUser: u.owned_by_current_user,
            ownerName: u.owner_name,
            uaId: u.unit_activity_id
          });
      }
    });
    return this.orderUnits(parsedUnits);
  };

  orderUnits = (units) => {
    const unitsArr = [];
    Object.keys(units).forEach(unitId => unitsArr.push(units[unitId]));
    return unitsArr;
  };

  setAllUnits = (data) => {
    this.setState({ allUnits: this.parseUnits(data), }, this.getUnitsForCurrentClassAndOpenState);
    this.hashLinkScroll();
  };

  switchClassrooms = (classroom) => {
    const { open, } = this.props
    window.localStorage.setItem(PROGRESS_REPORTS_SELECTED_CLASSROOM_ID, classroom.id)
    let baseLink = '/teachers/classrooms/activity_planner'
    baseLink += open ? '' : '/closed'
    if (classroom.id) {
      window.history.pushState({}, '', `${baseLink}?classroom_id=${classroom.id}`);
    } else {
      window.history.pushState({}, '', baseLink);
    }
    this.setState({ selectedClassroomId: classroom.value, }, () => this.getUnitsForCurrentClassAndOpenState());
  };

  stateBasedComponent = () => {
    const { open, } = this.props
    const { units, selectedClassroomId } = this.state

    const displayableUnits = units.filter(unit => unit.open === open)

    if (!displayableUnits.length && open) {
      return (
        <div className="my-activities-empty-state container">
          <h2>Start by assigning activities</h2>
          <p>Nothing to see here yet! Once you assign activities, they will show up here.</p>
        </div>
      )
    }

    if (!displayableUnits.length && !open) {
      return (
        <div className="my-activities-empty-state container">
          <h2>You have no closed activity packs</h2>
          <p>Closed activity packs are hidden from students. You can still access them in your reports.</p>
        </div>
      )
    }

    const activityPacks = displayableUnits.map(unit => (
      <ActivityPack
        data={unit}
        getUnits={this.getUnits}
        key={unit.unitId}
        selectedClassroomId={selectedClassroomId}
        showSnackbar={this.showSnackbar}
      />
    ))

    return (
      <section className="activity-packs container">
        {activityPacks}
      </section>
    )
  };

  getIdFromUnit = (unit) => {
    return unit.unitId || unit.unit.id;
  };

  showSnackbar = (snackbarCopy) => {
    this.setState({ showSnackbar: true, snackbarCopy }, () => {
      setTimeout(() => this.setState({ showSnackbar: false, }), defaultSnackbarTimeout)
    })
  }

  render() {
    const { open } = this.props
    const { classrooms, selectedClassroomId, loaded, showSnackbar, snackbarCopy, } = this.state

    if (!loaded) { return <LoadingIndicator /> }

    const allClassroomsClassroom = { label: ALL, value: ALL, };

    const dropdownOptions = [ALL_OPTION].concat(classrooms.map(c => ({ value: c.id, label: `<p><img alt="" src=${groupSrc} /><span>${c.name}</span></p>`, })))

    return (
      <React.Fragment>
        <main className="my-activities gray-background-accommodate-footer">
          <Snackbar text={snackbarCopy} visible={showSnackbar} />
          <section className="my-activities-header">
            <div className="container">
              <div>
                <h1>My {open ? 'Open' : 'Closed'} Activity Packs</h1>
                <div>
                  <DropdownInput
                    ariaLabel="Classroom"
                    className="medium bordered icon focus-on-light"
                    handleChange={this.switchClassrooms}
                    isSearchable={false}
                    options={dropdownOptions}
                    usesCustomOption={true}
                    value={dropdownOptions.find(opt => opt.value === selectedClassroomId)}
                  />
                  <a className="quill-button contained medium green focus-on-light" href="/assign">Assign activities</a>
                </div>
              </div>
            </div>
          </section>
          {this.stateBasedComponent()}
        </main>
        {open && <ArticleSpotlight blogPostId={MY_ACTIVITIES_FEATURED_BLOG_ID} />}
      </React.Fragment>
    );
  }
}
